import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class TranslateCanActivate implements CanActivateChild, CanActivate {

  constructor(private readonly translate: TranslateService) {
  }

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.getTranslate();
  }

  public canActivateChild(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.getTranslate();
  }


  getTranslate(): Observable<boolean> {
    return new Observable<boolean>(observer => {
      this.translate.getTranslation(this.translate.currentLang).subscribe({
        next: () => {
          observer.next(true);
          observer.complete();
        },
        error: (err) => {
        observer.error(err);
        }
      });
    });
  }
}
